import { Check, X } from "lucide-react";
import { useLanguage } from "@/lib/i18n";

export function ComparisonTable() {
  const { t } = useLanguage();

  const rows = [
    { criteriaKey: 'comparison.row1.criteria', regularKey: 'comparison.row1.regular', pdrnKey: 'comparison.row1.pdrn' },
    { criteriaKey: 'comparison.row2.criteria', regularKey: 'comparison.row2.regular', pdrnKey: 'comparison.row2.pdrn' },
    { criteriaKey: 'comparison.row3.criteria', regularKey: 'comparison.row3.regular', pdrnKey: 'comparison.row3.pdrn' },
    { criteriaKey: 'comparison.row4.criteria', regularKey: 'comparison.row4.regular', pdrnKey: 'comparison.row4.pdrn' },
    { criteriaKey: 'comparison.row5.criteria', regularKey: 'comparison.row5.regular', pdrnKey: 'comparison.row5.pdrn' },
  ];

  return (
    <section className="mb-8 md:mb-10">
      <h2 className="text-2xl md:text-3xl font-bold text-center mb-5 md:mb-7">
        {t('comparison.title')}
      </h2>
      <div className="bg-white/70 rounded-2xl md:rounded-3xl border border-white/80 shadow-sm overflow-hidden">
        {/* Header */}
        <div className="grid grid-cols-3 text-center text-xs md:text-sm font-bold border-b border-border/50">
          <div className="p-3 md:p-4" />
          <div className="p-3 md:p-4 text-muted-foreground bg-muted/30">
            {t('comparison.headerRegular')}
          </div>
          <div className="p-3 md:p-4 text-primary bg-primary/5">
            {t('comparison.headerPDRN')}
          </div>
        </div>

        {/* Rows */}
        {rows.map((row, idx) => (
          <div
            key={idx}
            className={`grid grid-cols-3 text-center text-xs md:text-sm ${
              idx < rows.length - 1 ? 'border-b border-border/30' : ''
            }`}
          >
            <div className="p-3 md:p-4 font-medium text-foreground text-start flex items-center">
              {t(row.criteriaKey)}
            </div>
            <div className="p-3 md:p-4 text-muted-foreground bg-muted/10 flex items-center justify-center gap-1.5">
              <X className="w-3.5 h-3.5 text-destructive flex-shrink-0" />
              <span className="leading-tight">{t(row.regularKey)}</span>
            </div>
            <div className="p-3 md:p-4 text-foreground bg-primary/5 flex items-center justify-center gap-1.5">
              <Check className="w-3.5 h-3.5 text-success flex-shrink-0" />
              <span className="leading-tight font-medium">{t(row.pdrnKey)}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
